{
  "questions": [
    {
      "id": 0,
      "question": "Qual a documentação necessária para concluir a contratação dos planos odontológicos da SulAmérica?",
      "answer": "Para a contratação online via SulAmérica Odonto Fácil não é necessário o envio de documentos. É preciso apenas verificar as condições contratuais, assim como os anexos disponibilizados, e concordar com os mesmos. Lembrando que a SulAmérica Odonto pode, a qualquer momento, solicitar à contratante documentação comprobatória relativa a este contrato."
    },
    {
      "id": 1,
      "question": "Quem pode ser incluído nos planos SulAmérica Odonto?",
      "answer": "Nossos planos destinam-se a todos vinculados à pessoa jurídica contratante. Incluindo os sócios, administradores, todos os funcionários, dependentes legais (cônjuge, companheiro(a), filhos(as), enteados(as) e tutelados(as), pai, mãe, irmãos, avós, netos(as), tios(as), sobrinhos(as), bisnetos(as), sogro(a), genro, nora, cunhados(as), padrasto e madrasta) do Beneficiário Titular. Verifique todas as condições de inclusão nas Condições Gerais do Plano."
    },
    {
      "id": 2,
      "question": "O valor mensal dos planos varia de acordo com a faixa etária dos beneficiários?",
      "answer": "O valor da mensalidade não varia de acordo com a faixa etária. O preço se altera conforme o plano escolhido e o número de beneficiários incluídos. Verifique nas informações de cada plano o valor da mensalidade por beneficiário."
    },
    {
      "id": 3,
      "question": "Quando será o início da vigência do plano?",
      "answer": "O início da vigência de qualquer plano escolhido se inicia a partir da zero hora do dia subsequente à quitação bancária da 1ª fatura mensal."
    },
    {
      "id": 4,
      "question": "Qual o prazo de vigência do contrato?",
      "answer": "A vigência do contrato dos Planos SulAmérica Odonto é de 24 meses."
    },
    {
      "id": 5,
      "question": "Quais são as coberturas dos Planos SulAmérica Odonto?",
      "answer": "Os Planos SulAmérica Odonto PME oferecem a cobertura integral do Rol de Procedimentos da ANS (Agência Nacional de Saúde Suplementar) na segmentação odontológica, além de coberturas adicionais conforme o Plano Contratado, sendo: Documentação Ortodôntica, Ortodontia, Clareamento convencional, Clareamento a laser, Próteses e Implante."
    },
    {
      "id": 6,
      "question": "Meus colaboradores terão a carteirinha do plano?",
      "answer": "Os beneficiários terão acesso à carteira de identificação de forma online no aplicativo SulAmérica Odonto. Além da carteirinha, o app conta com diversas funcionalidades, tais como a consulta da rede credenciada,  procedimentos cobertos, reembolso e muito mais."
    },
    {
      "id": 7,
      "question": "Como faço para consultar a rede de dentistas dos planos SulAmérica Odonto?",
      "answer": "A rede credenciada da SulAmérica Odonto tem abrangência nacional e pode ser consultada aqui no site, no aplicativo app SulAmérica Odonto ou pelos nossos canais de atendimento. \n- Central de Serviços (Coberturas Contratadas, Reembolso e demais solicitações): 3003-1159 \n- SAC (Reclamações, Cancelamentos e Informações Institucionais): 0800-722-0504."
    },
    {
      "id": 8,
      "question": "Quero utilizar o plano, por onde devo começar?",
      "answer": "Escolha um profissional credenciado de sua preferência, agende uma consulta e apresente sua carteirinha do plano, junto com um documento pessoal com foto. Após a realização do exame clínico, o dentista solicita o procedimento na plataforma online da SulAmérica Odonto e você pode iniciar o tratamento após a liberação."
    },
    {
      "id": 9,
      "question": "Devo pagar algum valor adicional ao dentista credenciado no momento da utilização do plano?",
      "answer": "Não há nenhum valor adicional para os procedimentos cobertos pelo plano contratado. Não há franquias ou coparticipação e todo o pagamento dos procedimentos cobertos será realizado pela SulAmérica Odonto diretamente ao dentista / clínica credenciada."
    },
    {
      "id": 10,
      "question": "Posso utilizar um dentista particular?",
      "answer": "Sim. A SulAmérica Odonto disponibiliza a opção de livre escolha. Uma vez que o dentista não faz parte da nossa rede credenciada, o reembolso das despesas para todos os procedimentos cobertos no plano irá seguir a tabela estabelecida."
    },
    {
      "id": 11,
      "question": "Quais bancos são aceitos para débito em conta?",
      "answer": "Os bancos que aceitam débito em conta são: Santander, Itaú e Bradesco."
    },
    {
      "id": 12,
      "question": "Qual o plano SulAmérica Odonto PME que cobre a manutenção de Ortodontia e/ou Implantes?",
      "answer": "Temos planos com cobertura de Ortodontia, Próteses e Implante, de acordo com a grade de planos abaixo: \n- MAIS: Rol Ampliado \n- MAIS DOC: Rol Ampliado + Documentação Ortodôntica \n- MAIS CLAREAR: Rol Ampliado + Clareamento convencional \n- MAIS ORTO: Rol Ampliado + Ortodontia \n- MAIS PRO: Rol Ampliado + Próteses \n- MAIS AMPLO: Rol Ampliado + Orto + Próteses + Clareamento convencional"
    },
    {
      "id": 13,
      "question": "Como faço para contratar o plano PME?",
      "answer": "1. Cadastre as informações de sua empresa e crie o login e senha. \n2. Escolha o plano de cada titular e não esqueça de incluir os dependentes. \n3. Confira o resumo da proposta com atençao e, se necessário, faça as devidas alterações. Em seguida clique em \"CONTRATAR\". \n\nDepois de clicar em “CONTRATAR”, a proposta é finalizada e não pode ser alterada. Caso queira realizar alguma alteração, será necessário o cancelamento e emissão de uma nova proposta. Para isso, basta clicar em “CANCELAR”, editar os dados e emitir uma nova proposta (será gerada uma nova proposta e um novo boleto correspondente). \n\nATENÇÃO: antes de cancelar qualquer proposta, certifique-se que não houve quitação do boleto."
    },
    {
      "id": 14,
      "question": "Concluí a proposta de plano, mas preciso alterar os dados dos meus beneficiários. Como devo proceder?",
      "answer": "Caso já tenha efetivado o pagamento do boleto, as orientações para realizar as alterações poderão ser solicitadas pela Central de Atendimento SulAmérica Odonto. Caso ainda não tenha pagado o boleto, basta clicar em \"CANCELAR\", voltar para a edição de dados do cadastro e emitir uma nova proposta (será gerada uma nova proposta e um novo boleto correspondente). \n\nATENÇÃO: antes de quitar o boleto, certifique-se de que este corresponde ao número da proposta válida."
    },
    {
      "id": 15,
      "question": "Como recuperar minha senha de acesso?",
      "answer": "Clique em \"Minha Proposta\", digite seu login de acesso (CNPJ) e depois clique em \"Esqueci minha senha\"."
    },
    {
      "id": 16,
      "question": "Tentei cadastrar minha empresa mas apareceu a mensagem de que já sou cliente. O que devo fazer?",
      "answer": "Entre em contato com a SulAmérica nos nossos canais de atendimento: \n- Central de Serviços (Coberturas Contratadas, Reembolso e demais solicitações): 3003-1159\n- SAC 0800-722 (Reclamações, Cancelamentos e Informações Institucionais): 0800-722-0504"
    }
  ]
}
